import { useQuery } from '@tanstack/vue-query'
import { getMyOrganizations } from '@/features/organizations/api/get-my-organizations'

export const MY_ORGANIZATIONS_QUERY_KEY = ['organizations', 'my'] as const

export function useMyOrganizations() {
  return useQuery({
    queryKey: MY_ORGANIZATIONS_QUERY_KEY,
    queryFn: getMyOrganizations,
  })
}
